import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { AdjustmentCategoryTypeModel } from '../models/adjustmentCategoryType.model';
import { InfraService } from './infra.service';

@Injectable()
export class AdjustmentCategoryTypeService {
  private configUrl: string;
  private pythonUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {
    //if (localStorage.getItem('selectedregion') == '1') {
    //  this.configUrl = environment.apiUrl + 'adjustmentCategoryType';
    //  this.pythonUrl = environment.pythonAPIUrl;
    //}
    //else {
    //  this.configUrl = environment.apiUrlRow + 'adjustmentCategoryType';
    //  this.pythonUrl = environment.pythonAPIUrlRow;
    //}
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint2 + 'adjustment';
      this.pythonUrl = data.PythonURL;
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }
  }

  public getAdjustmentCategoryTypes(): Observable<AdjustmentCategoryTypeModel[]> {
    return this.http.get<AdjustmentCategoryTypeModel[]>(`${this.configUrl}/GetAdjustmentCategoryTypes`);
    // .catch(this.handleError);
  }

  // public save(adjustmentData: AdjustmentModel) {
  //  return this.http.post(`${this.configUrl}`, adjustmentData);
  //  //.catch(this.handleError);
  // }

  // public update(adjustmentData: AdjustmentModel) {
  //  return this.http.put(`${this.configUrl}/${adjustmentData.id}`, adjustmentData);
  //  //.catch(this.handleError);
  // }

  private handleError(error: Response) {
    return throwError(()=> error);
  }


}
